import React, { useEffect, useState } from "react";
import { Button, Card, Col, Input, Row, FormGroup, Label, Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { connect } from "react-redux";
import BackButton from "../../../../../../../designUtils/Logo/BackButton.svg";
import GetWorkflowTaskService from "../../../../../../../Service/OPSServices/WorkflowsService/GetWorkflowTaskService";
import GetProgressBarDataService from "../../../../../../../Service/OPSServices/WorkflowsService/GetProgressBarDataService";
import ReactTable from "react-table";
import CustomModal from "../../../../../../Components/Modals/CustomModal";
import EditIcon from '../../../../../../../designUtils/OpsDashboard/AccountDetails/EditIcon.svg';
import TaskListDetailsPriviewModeComponents from "./TaskListDetailsPriviewModeComponents"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import GetAllWorkflowStatusService from "../../../../../../../Service/OPSServices/WorkflowsService/GetAllWorkflowStatusService";
import SaveTaskDetailsService from "../../../../../../../Service/OPSServices/WorkflowsService/SaveTaskDetailsService";
import { SetInnerHtmlWithClassReplacement } from "../../../../../../../Utils/Constants";
import WorkflowsOpenDrawerIcon from "../../../../../../../designUtils/Workflows/WorkflowsOpenDrawerIcon.svg";
import WorkflowsCloseDrawerIcon from "../../../../../../../designUtils/Workflows/WorkflowsCloseDrawerIcon.svg";
import ManageWorkflowsStartDateServices from "../../../../../../../Service/OPSServices/WorkflowsService/ManageWorkflowsStartDateServices";
import TaskDetailsComponents from "./TaskDetailsComponents";
import UpdatedTaskDetailsPreviewMode from "./UpdatedTaskDetailsPreviewMode";

function WorkflowUpdatedPhase(props) {
  const [teamMembers, setTeamMembers] = useState([]);
  const [workflowPhaseCount, setWorkflowPhaseCount] = useState([]);
  const [activeMasterPhase, setActiveMasterPhase] = useState(null);
  const [activeSubPhaseId, setActiveSubPhaseId] = useState(null);
  const [isPriviewModeOn, setIsPriviewModeOn] = useState(false);
  const [assignedMember, setAssignedMember] = useState("");
  const [isStartDatePopupOpen, setIsStartDatePopupOpen] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [taskList, setTaskList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [satusLoading, setSatusLoading] = useState(false);
  const [assignedLoading, setAssingedLoading] = useState(false);
  const [assignedDropdownOpen, setAssignedDropdownOpen] = useState({});
  const [selectedAssignedTo, setSelectedAssignedTo] = useState({});
  const [latestCommentPopup, setLatestCommentPopup] = useState(false);
  const [latestComment, setLatestComment] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [isOpneTaskListDetails, setIsOpneTaskListDetails] = useState(false);
  const [taskDetails, setTaskDetails] = useState(null);
  const [tempStartDate, setTempStartDate] = useState("");
  const [totalWorkflowPhaseCount, setTotalWorkflowPhaseCount] = useState(0);

  useEffect(() => {
    let data = {
      integerId: props.selectedStoreData ? props.selectedStoreData.integerId : "",
      workflowMasterId: props.selectedWorkflowMasterId,
      project: props.selectedProjectData ? props.selectedProjectData.projectId : ""
    };

    if (data.integerId && data.workflowMasterId) {
      GetWorkflowTaskService(props.token, data).then((res) => {
        if (res) {
          console.log(res)
          setSelectedStartDate(res.satrtDate)
          setTeamMembers(res.teamMembers || []);
          setTaskList(res.tasklist || []);

          if (props.flag && props.selectedTask) {
            const specificTask = res.tasklist && res.tasklist.find(t => 
              (props.selectedTask.taskId && t.id === props.selectedTask.taskId) || 
              (t.taskText === props.selectedTask.task)
            );

            let targetSubPhaseId = null;

            if (specificTask) {
              targetSubPhaseId = specificTask.WorkflowPhases;
              
              if (props.directTaskView) {
                setTaskDetails(specificTask);
                setIsOpneTaskListDetails(true);
                setIsPriviewModeOn(false);
              }
            } else if (props.selectedTask.phaseId) {
              targetSubPhaseId = props.selectedTask.phaseId;
            }

            if (targetSubPhaseId) {
              setActiveSubPhaseId(targetSubPhaseId);
              
              const targetPhaseObj = props.workflowPhases && props.workflowPhases.find(p => p.id === targetSubPhaseId);
              if (targetPhaseObj && targetPhaseObj.MasterPhase !== null && targetPhaseObj.MasterPhase !== undefined) {
                setActiveMasterPhase(String(targetPhaseObj.MasterPhase));
              }
            }
          }
        }
      });

      GetProgressBarDataService(props.token, data).then((response) => {
        if (response) setWorkflowPhaseCount(response.workflowPhasesCount || []);
      });
      
      GetAllWorkflowStatusService(props.token).then((response) => {
        if (response) {
          setStatusList(response.statusList);
        }
      });
    }
  }, [props.workflowPhases, props.selectedWorkflowMasterId, props.selectedStoreData, props.token, props.selectedProjectData, props.selectedTask, props.flag, props.directTaskView]);

  const handlePriviewMode = () => {
    setIsPriviewModeOn(!isPriviewModeOn);
    setIsOpneTaskListDetails(false); 
  };

  const handleAssignedToChange = (e) => setAssignedMember(e.target.value);

  const handleOpenTaskDetailsPage = (task) => {
    setIsPriviewModeOn(false);
    setIsOpneTaskListDetails(true);
    setTaskDetails(task);
  };

  const handleBackTaskList = () => {
    setIsOpneTaskListDetails(false);
  };

  const getSimpleDate = (dateStr) => {
    if (!dateStr) return "";
    
    let [year, month, day] = dateStr.split('T')[0].split('-');

    if (year && year.length === 2) {
      year = `20${year}`;
    }

    return `${year}-${month}-${day}`;
  };

  const filteredPhases = props.workflowPhases || [];

  const masterPhasesMap = {};
  filteredPhases.forEach((phase) => {
    const masterId = phase.MasterPhase !== null && phase.MasterPhase !== undefined ? phase.MasterPhase : 'null_phase';
    
    if (!masterPhasesMap[masterId]) {
      masterPhasesMap[masterId] = [];
    }
    masterPhasesMap[masterId].push(phase);
  });

  const masterPhaseTabs = props.workflowMasterPhases || [];

  const currentMasterPhase = (activeMasterPhase !== null)
    ? String(activeMasterPhase)
    : (masterPhaseTabs.length > 0 ? String(masterPhaseTabs[0].id) : null);

  const subPhasesList = (currentMasterPhase && masterPhasesMap[currentMasterPhase]) 
    ? masterPhasesMap[currentMasterPhase] 
    : [];

  const defaultSubPhaseId = (subPhasesList && subPhasesList.length > 0) ? subPhasesList[0].id : null;
  const currentSubPhaseId = activeSubPhaseId || defaultSubPhaseId;

  const handleMasterPhaseClick = (masterId) => {
    const strMasterId = String(masterId); 
    setActiveMasterPhase(strMasterId);
    setIsOpneTaskListDetails(false);
    
    if (masterPhasesMap[strMasterId] && masterPhasesMap[strMasterId].length > 0) {
      setActiveSubPhaseId(masterPhasesMap[strMasterId][0].id);
    } else {
      setActiveSubPhaseId(null);
    }
  };

  const getWorkflowName = () => {
    if (props.workflowMainCategory && props.selectedWorkflowMasterId) {
      const category = props.workflowMainCategory.find(
        (wf) => wf.id == props.selectedWorkflowMasterId
      );
      return category ? category.name : "";
    }
    return "";
  };

  const filteredGridTasks = taskList.filter((task) => {
    const matchesPhase = task.WorkflowPhases == currentSubPhaseId;

    let matchesAssignee = true;
    if (assignedMember) {
      const targetId = Number(assignedMember);

      if (selectedAssignedTo[task.id] !== undefined) {
        matchesAssignee = selectedAssignedTo[task.id].includes(targetId);
      } 
      else if (task.answerObject && task.answerObject[0] && task.answerObject[0].executor) {
        const executor = task.answerObject[0].executor;
        if (Array.isArray(executor)) {
          matchesAssignee = executor.map(Number).includes(targetId);
        } else {
          matchesAssignee = Number(executor) === targetId;
        }
      } else {
        matchesAssignee = false;
      }
    }
    return matchesPhase && matchesAssignee;
  });

  let totalTasksForMasterPhase = 0;
  let totalAttemptedForMasterPhase = 0;
  subPhasesList.forEach(subPhase => {
    const countData = workflowPhaseCount.find((c) => c.WorkflowPhases_id === subPhase.id);
    if (countData) {
      totalTasksForMasterPhase += countData.taskCount || 0;
      totalAttemptedForMasterPhase += countData.attemptedTaskCount || 0;
    }
  });
  const overallProgressPercent = totalTasksForMasterPhase > 0 
    ? Math.round((totalAttemptedForMasterPhase / totalTasksForMasterPhase) * 100) 
    : 0;

  const toggleAssignedDropdown = (taskId) => {
    setAssignedDropdownOpen(prevState => ({
      ...prevState,
      [taskId]: !prevState[taskId]
    }));
  };

  const saveTaskDetails = (type, value, taskDetailsToSave) => {
    if (!taskDetailsToSave) return;
    
    let data;
    if (type === 'assignedTo') {
      setAssingedLoading(taskDetailsToSave.id);
      data = {
        taskId: taskDetailsToSave.id,
        taskText: 'assignedTo',
        workflowMasterId: props.selectedWorkflowMasterId,
        assignedTo: value !== undefined ? value : (taskDetailsToSave.answerObject && taskDetailsToSave.answerObject[0] ? taskDetailsToSave.answerObject[0].executor : 0),
        workflowPhaseId: currentSubPhaseId,
        integerId: props.selectedStoreData ? props.selectedStoreData.integerId : "",
        status: (taskDetailsToSave.answerObject && taskDetailsToSave.answerObject[0]) ? taskDetailsToSave.answerObject[0].status : 0,
        attachmentFile: [],
        brand: props.selectedProjectData ? props.selectedProjectData.brandId : '',
        project: props.selectedProjectData ? props.selectedProjectData.projectId : '',
      };
    } else if (type === 'status') {
      setSatusLoading(taskDetailsToSave.id);
      data = {
        taskId: taskDetailsToSave.id,
        taskText: 'status',
        workflowMasterId: props.selectedWorkflowMasterId,
        assignedTo: (taskDetailsToSave.answerObject && taskDetailsToSave.answerObject[0]) ? taskDetailsToSave.answerObject[0].executor : 0,
        workflowPhaseId: currentSubPhaseId,
        integerId: props.selectedStoreData ? props.selectedStoreData.integerId : "",
        status: value ? value : ((taskDetailsToSave.answerObject && taskDetailsToSave.answerObject[0]) ? taskDetailsToSave.answerObject[0].status : 0),
        attachmentFile: [],
        brand: props.selectedProjectData ? props.selectedProjectData.brandId : '',
        project: props.selectedProjectData ? props.selectedProjectData.projectId : '',
      };
    } else {
      return;
    }
    console.log(data)
    // return

    SaveTaskDetailsService(props.token, data).then((res) => {
      if (res && res.status) {
        setTaskList(res.tasklist.tasklist);
        setWorkflowPhaseCount(res.progressBarData.workflowPhasesCount);
        setSatusLoading(false);
        setAssingedLoading(false);
      }
    });
  };

  const handleStatusChange = (e, task) => {
    saveTaskDetails('status', e.target.value, task);
  };

  const handleAssignedCheckboxChange = (taskId, memberId, task) => {
    let currentSelected = selectedAssignedTo[taskId];

    if (currentSelected === undefined) {
      if (task && task.answerObject && task.answerObject[0] && task.answerObject[0].executor) {
        const executor = task.answerObject[0].executor;
        currentSelected = Array.isArray(executor) ? executor.map(Number) : [Number(executor)];
      } else {
        currentSelected = [];
      }
    }

    let updatedMembers = [...currentSelected];
    const numericMemberId = Number(memberId);

    if (updatedMembers.includes(numericMemberId)) {
      updatedMembers = updatedMembers.filter(id => id !== numericMemberId);
    } else {
      updatedMembers.push(numericMemberId);
    }

    setSelectedAssignedTo(prev => ({ ...prev, [taskId]: updatedMembers }));
    saveTaskDetails('assignedTo', updatedMembers, task);
  };

  const getSelectedAssignedNames = (taskId, teamMembersList, task) => {
    let selectedIds = selectedAssignedTo[taskId];

    if (selectedIds === undefined) {
      let executor = (task && task.answerObject && task.answerObject[0] && task.answerObject[0].executor) 
        ? task.answerObject[0].executor 
        : null;

      if (Array.isArray(executor)) {
        selectedIds = executor.map(Number);
      } else if (executor) {
        selectedIds = [Number(executor)];
      } else {
        selectedIds = [];
      }
    }

    if (selectedIds.length === 0) return "-- Assigned to --";

    const assignedNames = (teamMembersList || [])
      .filter(member => selectedIds.includes(Number(member.employeeId)))
      .map(member => member.employeeName)
      .join(", ");
      
    return assignedNames.trim() === "" ? "-- Assigned to --" : assignedNames;
  };

  const viewLatestComment = (text) => {
    setLatestCommentPopup(true);
    setLatestComment(text || "");
  };

  const stripHtmlTags = (html) => {
    if (!html) return '';
    return html.replace(/<[^>]*>/g, '');
  };

  const gridComments = SetInnerHtmlWithClassReplacement ? SetInnerHtmlWithClassReplacement(latestComment) : latestComment;

  const gridColumns = [
    { 
      Header: "Task", 
      accessor: "taskText",
      width: 350, 
      Cell: (cellInfo) => (
        <div className="d-flex align-items-center w-100" style={{ overflow: "hidden", paddingLeft: "10px" }}>
          <a 
            href="#" 
            onClick={(e) => {
              e.preventDefault();
              handleOpenTaskDetailsPage(cellInfo.original);
            }}
            style={{ color: "#3D85C6", textDecoration: "underline", width: "100%", textAlign: "left", overflow: "hidden" }}
            title={cellInfo.value} 
          >
            <p 
              className="m-0 comment-paragraph" 
              style={{ 
                whiteSpace: "nowrap", 
                overflow: "hidden", 
                textOverflow: "ellipsis",
                width: "100%"
              }}
            >
              {cellInfo.value}
            </p>
          </a>
        </div>
      ),
    },
    { 
      Header: "Status", 
      id: "status",
      width: 160, 
      Cell: ({ original: task }) => {
        if (satusLoading === task.id) {
          return <p className="mb-0" style={{ color: "#81e94b" }}>Updating..</p>;
        }
        if (task.answerObject && task.answerObject[0] && task.answerObject[0].status === 6) {
          return (
            <div className="mt-1 d-flex flex-column align-items-center w-100">
              <span className="signedoff-dropdown">
                Signed Off &nbsp; &nbsp; <FontAwesomeIcon style={{ color: "#fff" }} icon={faCheck} />
              </span>
              <p className="ml-2 mt-2 mb-0" style={{ color: "#333", fontSize: "13px" }}>
                {(() => {
                  let rawName = getSelectedAssignedNames(task.id, task.teamMembers || teamMembers, task);
                  
                  if (rawName === "-- Assigned to --") {
                    rawName = task.answerObject[0].executorName || task.answerObject[0].updatedByName || "";
                  }
                  
                  if (!rawName) return "";
                  
                  return rawName.split(", ").map(name => {
                    const parts = name.trim().split(" ");
                    return parts.length > 1 ? `${parts[0]} ${parts[1][0]}.` : parts[0];
                  }).join(", ");
                })()}
              </p>
            </div>
          );
        }
        
        const currentStatus = (task.answerObject && task.answerObject[0]) ? task.answerObject[0].status : null;
        const selectClass = currentStatus === 3 ? "inprogress-dropdown form-control"
                          : currentStatus === 5 ? "completed-dropdown form-control"
                          : currentStatus === 2 ? "notstarted-dropdown form-control"
                          : currentStatus === 1 ? "notapplicable-dropdown form-control"
                          : currentStatus === 4 ? "postpond-dropdown form-control"
                          : "form-control";

        return (
          <div className="d-flex justify-content-center w-100 ">
            <select
              className={`w-100 ${selectClass}`}
              value={currentStatus || ""}
              onChange={(e) => handleStatusChange(e, task)}
            >
              <option style={{ background: "#fff" }} value="">-- Select status --</option>
              {statusList && statusList.map((status) => (
                <option style={{ background: "#fff" }} key={status.id} value={status.id}>
                  {status.status}
                </option>
              ))}
            </select>
          </div>
        );
      }
    },
    {
      Header: "Due Date",
      id: "dueDate",
      width: 140,
      Cell: ({ original: task }) => {
        const dateValue =
          task.ageTask && task.ageTask.dueDate
            ? task.ageTask.dueDate.split("T")[0]
            : " ";
    
        const bgColor =
          task.ageTask && task.ageTask.colourCode
            ? task.ageTask.colourCode
            : "transparent";
    
        return (
          <div className="d-flex justify-content-center align-items-center w-100">
            <span
              className="due-date-pill"
              style={{ backgroundColor: bgColor }}
            >
              {dateValue}
            </span>
          </div>
        );
      },
    },
    { 
      Header: "Responsible Team", 
      id: "responsibleTeam",
      Cell: ({ original: task }) => {
        const rolesText = task.roleName && task.roleName.length > 0 
          ? task.roleName.join(", ") 
          : "";

        return (
          <div className="d-flex justify-content-center w-100 ">
            <p 
              className="m-0 comment-paragraph" 
              title={rolesText} 
            >
              {rolesText}
            </p>
          </div>
        );
      },
    },
    { 
      Header: "Assigned To", 
      id: "assignedTo",
      Cell: ({ original: task }) => {
        if (task.answerObject && task.answerObject[0] && task.answerObject[0].status === 6) {
          const assignedNames = getSelectedAssignedNames(task.id, task.teamMembers || teamMembers, task);
          return (
            <div className="d-flex justify-content-center w-100 ">
              <h6 className="ml-2 m-0">
                {assignedNames !== "-- Assigned to --" 
                  ? assignedNames 
                  : (task.answerObject[0].executorName || "")}
              </h6>
            </div>
          );
        }
        if (assignedLoading === task.id) {
          return (
            <div className="d-flex justify-content-center w-100 ">
              <p className="mb-0" style={{ color: "#81e94b" }}>Updating..</p>
            </div>
          );
        }

        const assignedNames = getSelectedAssignedNames(task.id, task.teamMembers || teamMembers, task);
        
        return (
          <div className="d-flex flex-column align-items-center w-100">
            <Dropdown 
              isOpen={assignedDropdownOpen[task.id] || false} 
              toggle={() => toggleAssignedDropdown(task.id)} 
              className="w-100"
            >
              <DropdownToggle 
                caret 
                className="form-control d-flex justify-content-between align-items-center"
                style={{ backgroundColor: 'white', color: '#495057', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '90%' }}>
                  {assignedNames}
                </span>
              </DropdownToggle>
              <DropdownMenu style={{ width: '100%', maxHeight: '200px', overflowY: 'auto', padding: '10px' }}>
                {(task.teamMembers || teamMembers).map((member) => (
                  <FormGroup check key={member.employeeId} className="m-2">
                    <Label check style={{ cursor: 'pointer', width: '100%' }}>
                      <Input 
                        type="checkbox" 
                        checked={
                          selectedAssignedTo[task.id] !== undefined
                            ? selectedAssignedTo[task.id].includes(Number(member.employeeId))
                            : ((task.answerObject && task.answerObject[0] && task.answerObject[0].executor)
                                ? (Array.isArray(task.answerObject[0].executor) 
                                    ? task.answerObject[0].executor.map(Number) 
                                    : [Number(task.answerObject[0].executor)]) 
                                : []
                              ).includes(Number(member.employeeId))
                        }
                        onChange={() => handleAssignedCheckboxChange(task.id, member.employeeId, task)}
                      />
                      {member.employeeName}
                    </Label>
                  </FormGroup>
                ))}
              </DropdownMenu>
            </Dropdown>
            {assignedNames !== "-- Assigned to --" && (
              <div className="w-100 mt-1 marquee-container" style={{ padding: "4px 0" }}>
                <div className="marquee-text" style={{ color: "black", fontSize: "13px" }}>
                  {assignedNames}
                </div>
              </div>
            )}
          </div>
        );
      }
    },
    { 
      Header: "Last Update", 
      accessor: "lastModified",
      width: 100, 
      Cell: (cellInfo) => {
        const val = cellInfo.value || "";
        let datePart = val;
        let timePart = "";
        
        if (val.includes("T")) {
          [datePart, timePart] = val.split("T");
          timePart = timePart.split(".")[0]; 
        } else if (val.includes(" ")) {
          [datePart, timePart] = val.split(" ");
        }

        return (
          <div className="d-flex flex-column justify-content-start align-items-start w-100 pl-2">
            <p className="m-0 comment-paragraph">{datePart}</p>
            {timePart && <p className="m-0 comment-paragraph">{timePart}</p>}
          </div>
        );
      },
    },
    { 
      Header: "Latest Comment", 
      id: "lastComment",
      Cell: ({ original: task }) => {
        const memoText = (task.answerObject && task.answerObject[0] && task.answerObject[0].memo) 
          ? task.answerObject[0].memo 
          : "";

        return (
          <div className="d-flex justify-content-center w-100 ">
            <p
              className="m-0 comment-paragraph-workflows"
            style={{ color: "#3D85C6", cursor: "pointer" }}
            onClick={() => viewLatestComment(memoText)}
          >
            {stripHtmlTags(memoText)}
          </p>
          </div>
        );
      }
    }
  ];

  const  manageStartDateOfWorkflows=(date)=>{

    let data={
      startDate:date,
      integerId:props.selectedStoreData ? props.selectedStoreData.integerId : "",
      masterWorkflow:props.selectedWorkflowMasterId
    }
    ManageWorkflowsStartDateServices(props.token, data).then((res)=>{
      if(res){
        console.log(res)
        setTaskList(res.tasks.tasklist || []);
      }
    })

  }
  return (
    <>
    {!props.hideBackButton && !props.isMyworksScreen && (
      <Card className="project-header-card border mb-2 mt-3 p-2 text-center">
        <h4 className="project-header-title mb-0">
          <b>Workflow </b>
        </h4>
      </Card>
      )}

      <Card className="mb-2 card-of-problemarea mt-3">
        <Row className="mt-2 mb-3 mx-0">
          <Col md={8} className="d-flex align-items-center">
            {!props.hideBackButton && (
              <button
                onClick={props.handleBackButtonToWorkflow}
                className={`hover-btn-link back-btn mr-3 ${isPriviewModeOn ? 'mb-2' : ''}`}
              >
                <img src={BackButton} alt="Back" />
              </button>
            )}
            
            <h5 
              className="mb-0 comment-paragraph-updated-workflow" 
              style={{ cursor: "pointer" }}
              title={props.selectedStoreData ? props.selectedStoreData.storeName : ""}
            >
              <b>{(props.selectedStoreData && props.selectedStoreData.storeName) || "STORE NAME"}</b>
            </h5>
            
            <h5 className="mb-0">
              &nbsp; : &nbsp;<b>{getWorkflowName()}</b>
            </h5>
            
            <span className="ml-5 mt-1 font-weight-bold d-flex align-items-center" style={{ fontSize: "16px" }}>
              Start Date : <span className="ml-2 font-weight-normal">{selectedStartDate ?selectedStartDate: "--"}</span>
              <img 
                src={EditIcon} 
                alt="Edit" 
                style={{ width: "16px", height: "16px", cursor: "pointer", marginLeft: "10px" }} 
                onClick={() => {
                  setTempStartDate(getSimpleDate(selectedStartDate));
                  setIsStartDatePopupOpen(true);
              }}
              />
            </span>
          </Col>

          <Col md={4} className="d-flex align-items-center justify-content-end">
            <label className="toggle-switch mb-0">
              <input type="checkbox" onChange={handlePriviewMode} checked={isPriviewModeOn} />
              <span className="dot"></span>
            </label>
            <p className="custom-label ml-2 mr-4 mb-0" style={{ whiteSpace: "nowrap" }}>
              View All Tasks
            </p>

            <Input 
              type="select"
              className="form-control mr-4" 
              style={{ width: "220px" }}
              value={assignedMember}
              onChange={handleAssignedToChange}
            >
              <option value="">-- Assigned To --</option>
              {teamMembers && teamMembers.map((m) => (
                <option key={m.employeeId} value={m.employeeId}>
                  {m.employeeName}
                </option>
              ))}
            </Input>
          </Col>
        </Row>
      </Card>

      {!isPriviewModeOn ? (
        <Card className="pt-3 pb-3 mb-2 card-of-problemarea mt-3">
          <Row className="mb-3 mx-0 border-bottom">
            <Col md={12} className="d-flex flex-wrap justify-content-start">
              {masterPhaseTabs.map((masterTab) => {
                const masterId = String(masterTab.id);
                const isActive = currentMasterPhase === masterId;
                const displayPhaseName = masterTab.phase ? masterTab.phase.toUpperCase() : `PHASE ${masterId}`;

                return (
                  <div
                    key={masterId}
                    onClick={() => handleMasterPhaseClick(masterId)}
                    style={{ cursor: "pointer" }}
                    className={isActive ? "selected-tab-workflows mr-4 mb-2" : "pt-3 pb-3 mr-4 mb-2"}
                  >
                    <p className="text-center p-0 mb-0" style={{ fontSize: "15px" }}>
                      <b>{displayPhaseName}</b>
                    </p>
                  </div>
                );
              })}
            </Col>
          </Row>

          <div className="d-flex w-100 mt-3 position-relative align-items-start px-2">
            
            {isDrawerOpen ? (
              <div className="workflow-sidebar position-relative pr-2" style={{ flex: "0 0 340px", width: "340px", minHeight: "400px" }}>        
                <div className="workflow-progress-container ml-3">
                  <div className="workflow-progress-text">
                    <span>Overall Progress</span>
                    <span>{totalAttemptedForMasterPhase} of {totalTasksForMasterPhase} Completed</span>
                  </div>
                  <div className="workflow-progress-track">
                    <div className="workflow-progress-bar" style={{ width: String(overallProgressPercent) + "%" }}></div>
                  </div>
                  <div className="workflow-progress-percentage">{overallProgressPercent}%</div>
                </div>

                <div className="workflow-subphase-list pb-5">
                  {subPhasesList.map((subPhase, index) => {
                    const isActiveSub = currentSubPhaseId === subPhase.id;
                    const countData = workflowPhaseCount.find((c) => c.WorkflowPhases_id === subPhase.id);
                    const attempted = countData ? countData.attemptedTaskCount || 0 : 0;
                    const total = countData ? countData.taskCount || 0 : 0;
                    const isCompleted = total > 0 && attempted === total;
                    const idxStr = String(index + 1).padStart(2, '0');

                    let iconStatusClass = isActiveSub ? 'active' : (isCompleted ? 'completed' : 'pending');
                    let textStatusClass = isActiveSub ? 'active' : (isCompleted ? 'completed' : '');

                    return (
                      <div
                        key={subPhase.id}
                        onClick={() => {
                          setActiveSubPhaseId(subPhase.id);
                          setIsOpneTaskListDetails(false); 
                      }}
                        className={`workflow-subphase-item ${isActiveSub ? 'active' : ''}`}
                      >
                        <div className="workflow-subphase-item-left">
                          {isCompleted && !isActiveSub ? (
                             <div className={`workflow-subphase-icon ${iconStatusClass}`}>
                               &#10003;
                             </div>
                          ) : (
                            <div className={`workflow-subphase-icon ${iconStatusClass}`}>
                              {idxStr}
                            </div>
                          )}
                          <span className={`workflow-subphase-name ${isActiveSub ? 'active' : ''}`}>
                            {subPhase.name}
                          </span>
                        </div>
                        
                        <div className="workflow-subphase-status-container">
                          <span className={`workflow-subphase-status ${textStatusClass}`}>
                            {isCompleted ? "Completed" : String(attempted) + " of " + String(total) + " Completed"}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
                
                <div 
                  className="drawer-toggle-btn"
                  onClick={() => setIsDrawerOpen(false)}
                >
                  <img src={WorkflowsCloseDrawerIcon} alt="Close Sidebar" style={{ width: "24px", height: "24px" }} />
                </div>
              </div>
            ) : (
              <div className="d-flex flex-column align-items-center pt-2" style={{ flex: "0 0 50px", width: "50px", minHeight: "400px" }}>
                <div className="d-flex flex-column align-items-center pt-2 position-relative" style={{ flex: "0 0 50px", width: "50px", minHeight: "400px" }}>
                  <div 
                    className="drawer-toggle-btn"
                    onClick={() => setIsDrawerOpen(true)}
                  >
                    <img src={WorkflowsOpenDrawerIcon} alt="Open Sidebar" style={{ width: "20px", height: "20px" }} />
                  </div>
                </div>
              </div>
            )}

            <div 
              style={{ flex: "1", minWidth: 0, overflowX: "auto" }} 
              className={`pl-3 ${isDrawerOpen ? "border-left" : "ml-4"}`}
            >
              {!isOpneTaskListDetails ? (
                <ReactTable
                  data={filteredGridTasks} 
                  columns={gridColumns}
                  className="-striped -highlight"
                  getTheadProps={() => {
                    return {
                      style: { overflowY: "hidden", background: "#B1FA63", color: "#243837" },
                    };
                  }}
                  defaultPageSize={10}
                  showPagination={true} 
                  noDataText={"No Tasks Found."}
                />
              ) : (
                <TaskDetailsComponents
                  selectedProjectData={props.selectedProjectData}
                  taskList={filteredGridTasks}
                  isOpneTaskListDetails={isOpneTaskListDetails}
                  workflowMainCategory={props.workflowMainCategory}
                  workflowPhases={props.workflowPhases}
                  selectedWorkflowMasterId={props.selectedWorkflowMasterId}
                  currentPhaseId={currentSubPhaseId}
                  taskDetails={taskDetails}
                  handleBackTaskList={handleBackTaskList}
                  setCurrentPhaseId={setActiveSubPhaseId}
                  statusList={statusList}
                  setTaskDetails={setTaskDetails}
                  setTaskList={setTaskList}
                  setAllTasks={setTaskList}
                  selectedStoreData={props.selectedStoreData}
                  teamMembers={teamMembers}
                  setWorkflowPhaseCount={setWorkflowPhaseCount}
                  isMyworksScreen={props.isMyworksScreen}
                  setTotalWorkflowPhaseCount={setTotalWorkflowPhaseCount}
                />
              )}
            </div>

          </div>
        </Card>
      ) : (
        <UpdatedTaskDetailsPreviewMode
          workflowPhases={props.workflowPhases}
          workflowMasterPhases={props.workflowMasterPhases}
          workflowMainCategory={props.workflowMainCategory}
          selectedWorkflowMasterId={props.selectedWorkflowMasterId}
          currentPhaseId={currentSubPhaseId} 
          taskList={taskList}                
          statusList={statusList}            
          setStatusList={setStatusList}
          selectedStoreData={props.selectedStoreData}
          teamMembers={teamMembers}
          setWorkflowPhaseCount={setWorkflowPhaseCount}
          setTaskList={setTaskList}
          handleOpenTaskDetailsPage={handleOpenTaskDetailsPage}
          assignedMember={assignedMember}
          setTotalWorkflowPhaseCount={setTotalWorkflowPhaseCount}
        />
      )}

      <CustomModal
        header={"Select Start Date"}
        isOpen={isStartDatePopupOpen}
        toggle={() => setIsStartDatePopupOpen(!isStartDatePopupOpen)}
        size={"sm"}
        className='curve-popup'
    >
        <FormGroup>
          <Label>Start Date</Label>
          <Input 
            type="date"
            value={tempStartDate || ""}
            onChange={(e) => { setTempStartDate(e.target.value); }}
            />
        </FormGroup>
        
                <div className="d-flex justify-content-end mt-3">
                    <Button 
                        className="btn-send-approval mr-3"
                        disabled={!tempStartDate}
                        onClick={() => {
                          setSelectedStartDate(tempStartDate);
                          manageStartDateOfWorkflows(tempStartDate);
                          setIsStartDatePopupOpen(false); 
                      }}
                    >
                        Done
                    </Button>
                    <Button
                        color={"link"}
                        onClick={() => setIsStartDatePopupOpen(!isStartDatePopupOpen)}
                    >
                        Cancel
                    </Button>
                </div>
      </CustomModal>
      <CustomModal
        header={"Latest Comment"}
        isOpen={latestCommentPopup}
        toggle={() => setLatestCommentPopup(!latestCommentPopup)}
        size={"lg"}
        className='curve-popup'
        footer={
          <>
            <Button color={"link"} onClick={() => setLatestCommentPopup(!latestCommentPopup)}>Cancel</Button>
          </>
        }
      >
        <Label>
          <p className="issue-discription-set" dangerouslySetInnerHTML={{ __html: gridComments }} />
        </Label>
      </CustomModal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
  };
};

export default connect(mapStateToProps)(WorkflowUpdatedPhase);